import React from 'react'

const DeleteIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2923_63227"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24"
      >
        <rect x="0.5" width="24" height="24" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_2923_63227)">
        <path
          d="M7.5 21C6.95 21 6.47933 20.8043 6.088 20.413C5.696 20.021 5.5 19.55 5.5 19V6C5.21667 6 4.979 5.90433 4.787 5.713C4.59567 5.521 4.5 5.28333 4.5 5C4.5 4.71667 4.59567 4.479 4.787 4.287C4.979 4.09567 5.21667 4 5.5 4H9.5C9.5 3.71667 9.596 3.479 9.788 3.287C9.97933 3.09567 10.2167 3 10.5 3H14.5C14.7833 3 15.021 3.09567 15.213 3.287C15.4043 3.479 15.5 3.71667 15.5 4H19.5C19.7833 4 20.0207 4.09567 20.212 4.287C20.404 4.479 20.5 4.71667 20.5 5C20.5 5.28333 20.404 5.521 20.212 5.713C20.0207 5.90433 19.7833 6 19.5 6V19C19.5 19.55 19.3043 20.021 18.913 20.413C18.521 20.8043 18.05 21 17.5 21H7.5ZM9.5 16C9.5 16.2833 9.596 16.5207 9.788 16.712C9.97933 16.904 10.2167 17 10.5 17C10.7833 17 11.021 16.904 11.213 16.712C11.4043 16.5207 11.5 16.2833 11.5 16V9C11.5 8.71667 11.4043 8.479 11.213 8.287C11.021 8.09567 10.7833 8 10.5 8C10.2167 8 9.97933 8.09567 9.788 8.287C9.596 8.479 9.5 8.71667 9.5 9V16ZM13.5 16C13.5 16.2833 13.596 16.5207 13.788 16.712C13.9793 16.904 14.2167 17 14.5 17C14.7833 17 15.021 16.904 15.213 16.712C15.4043 16.5207 15.5 16.2833 15.5 16V9C15.5 8.71667 15.4043 8.479 15.213 8.287C15.021 8.09567 14.7833 8 14.5 8C14.2167 8 13.9793 8.09567 13.788 8.287C13.596 8.479 13.5 8.71667 13.5 9V16Z"
          fill="#CCCFD6"
        />
      </g>
    </svg>
  )
}

export default DeleteIcon
